export default __webpack_public_path__ + "static/media/encircledGreenTick.9f5aaaca.svg";